import { useEffect, useRef } from "react";
import { Chart, ArcElement, DoughnutController, Tooltip } from "chart.js";
import "./PressureGauge.css";
import fire from "../../images/fire.svg";

Chart.register(ArcElement, DoughnutController, Tooltip);

const TOTAL_SEGMENTS = 20;
const GAP = 0.4;

export default function PressureGauge({ value = 0, zoneLabel, showFlame,testData }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);




const hexToRgb = (hex) => {
  const bigint = parseInt(hex.replace("#", ""), 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
};

const startColor = hexToRgb(`${testData?.test_detail?.left_color_1}`);
const endColor   = hexToRgb(`${testData?.test_detail?.left_color_2}`); 

const interpolateColor = (start, end, factor) => {
  const result = {
    r: Math.round(start.r + factor * (end.r - start.r)),
    g: Math.round(start.g + factor * (end.g - start.g)),
    b: Math.round(start.b + factor * (end.b - start.b)),
  };

  return `rgb(${result.r}, ${result.g}, ${result.b})`;
};

const getSegmentColor = (segmentIndex) => {

  const factor = segmentIndex / (TOTAL_SEGMENTS - 1);
  return interpolateColor(startColor, endColor, factor);
};

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    const segmentValue = (100 - TOTAL_SEGMENTS * GAP) / TOTAL_SEGMENTS;

    const data = [];
    const colors = [];

    for (let i = 0; i < TOTAL_SEGMENTS; i++) {
      data.push(segmentValue);
      colors.push(`${testData?.test_detail?.right_color_1}`); 
      data.push(GAP);
      colors.push("transparent");
    }

    chartRef.current = new Chart(ctx, {
      type: "doughnut",
      data: {
        datasets: [
          {
            data,
            backgroundColor: colors,
            borderWidth: 0,
            hoverBackgroundColor: colors,
          },
        ],
      },
      options: {
        rotation: -90,
        circumference: 180,
        cutout: "68%",
        responsive: false,
        plugins: {
          tooltip: { enabled: false },
          legend: { display: false },
        },
        animation: {
          duration: 1200,
          easing: "easeOutCubic",
        },
        events: [],
      },
    });

    return () => chartRef.current?.destroy();
  }, []);

useEffect(() => {
  if (!chartRef.current) return;

  const chart = chartRef.current;
  const filledCount = Math.round((value / 100) * TOTAL_SEGMENTS);

  const newColors = [];

  for (let i = 0; i < TOTAL_SEGMENTS; i++) {
   
    if (i < filledCount) {
      newColors.push(getSegmentColor(i));
    } else {
      newColors.push(`${testData?.test_detail?.right_color_1}`); 
    }

    newColors.push("transparent"); 
  }

  chart.data.datasets[0].backgroundColor = newColors;
  chart.update();
}, [value]);

  return (
    <div className="gauge-wrapper">
      <div className="gauge-card">
        <div className="gauge-chart-container">
          <canvas ref={canvasRef} className="gauge-canvas" />

          {showFlame && (
            
            <div className="gauge-flame-icon">
              <img src={fire} alt="" />
            </div>

          )}

          <div className="gauge-value-container">
            <span className="gauge-value-text">{value}%</span>
          </div>
          
        </div>
      </div>
    </div>
  );
}
